






































































import { Component, Prop, Vue } from 'vue-property-decorator';
import HomeFooterItem from '@/components/home/HomeFooterItem.vue';
import * as c_Interface from '@/interface/components/home';

@Component({
  components: { HomeFooterItem },
})
export default class HomeFooterSection extends Vue {
  public footerItems: Array<c_Interface.FooterItems> = [
    { name: '회사소개', to: 'https://www.datasee.co.kr/10056d41-58e0-4a1f-a090-9be460950dad' },
    { name: '문의하기', to: 'https://labsby.channel.io' },
    {
      name: '개인정보처리방침',
      to: 'https://www.datasee.co.kr/3576195d-a743-4942-b36a-670e211a10cf',
    },
    { name: '이용약관', to: 'https://www.datasee.co.kr/5139052e-4018-4742-9901-86af68c7cf36' },
  ];
}
